<template>
<div class="chapter">
<div class="inner_page">
<div class="galley-rw">
<section class="frontmatter-rw TitlePage-rw exclude-print-rw" epub:type="frontmatter titlepage" id="BookTitlePage1">
<div class="BookTitlePage" id="page-v">
<div class="center">
<div class="pc">
<img alt="Book Title Page" src="images/Art_tit.jpg" style="height: 95%;"/>
</div>
</div>
</div>
</section>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// titlepage.vue?058f17d2